import { gql } from "@grandvisionhq/graphql";
const productPriceItemFragment = gql`
  fragment productPriceItemFragment on ProductPriceItem {
    priceType
    loyaltyPoints
    pricePerUnit {
      amount
    }
    priceSegment {
      channelKey
    }
    originalPrice {
      amount
      currencyCode
    }
    discountedPrice {
      price {
        amount
        currencyCode
      }
      discountInformation {
        type
        value
        description {
          value
          locale
        }
        validity {
          validFrom
          validUntil
        }
      }
    }
  }
`;
export {
  productPriceItemFragment
};
//# sourceMappingURL=productPriceItem.js.map
